import WorkspaceLogoBase from './WorkspaceLogo.js';
import WorkspaceLogoIcon from './WorkspaceLogoIcon.js';
export { Wrapper } from './WorkspaceLogo.styles.js';

const WorkspaceLogo = Object.assign(WorkspaceLogoBase, {
    Icon: WorkspaceLogoIcon,
});

export { WorkspaceLogo };
